(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_023d6fc"] && !Shopify.designMode) return;
  try {
    (() => {
    const TAG = 'saber-email-popup';

    if (!window.customElements || customElements.get(TAG)) return;

    class SaberEmailPopup extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;

        this._ready = true;
        this.init();
      }

      disconnectedCallback() {
        this.destroy();
      }

      init() {
        this.enabled = this.bool('enabled');
        this.trigger = this.dataset.trigger || 'delay_or_scroll';
        this.delay = this.number('delay', 7);
        this.scrollPercent = this.number('scroll', 35);
        this.showDesktop = this.bool('showDesktop');
        this.showMobile = this.bool('showMobile');
        this.backdropClose = this.bool('backdropClose');
        this.showLauncherSetting = this.bool('showLauncher');
        this.showInterests = this.bool('showInterests');
        this.requireInterest = this.bool('requireInterest');
        this.customerSubscribed = this.bool('customerSubscribed');
        this.blockId = this.dataset.blockId || '';
        this.formId = this.dataset.formId || '';
        this.designMode = Boolean(window.Shopify && window.Shopify.designMode);

        this.backdrop = this.querySelector('[data-backdrop]');
        this.modal = this.querySelector('[data-modal]');
        this.form = this.querySelector('form');
        this.formState = this.querySelector('[data-form-state]');
        this.formPanel = this.querySelector('[data-form-panel]');
        this.successPanel = this.querySelector('[data-success-panel]');
        this.email = this.querySelector('[data-email]');
        this.firstName = this.querySelector('[data-first-name]');
        this.tags = this.querySelector('[data-tags]');
        this.interests = Array.from(this.querySelectorAll('[data-interest]'));
        this.interestGroup = this.querySelector('[data-interests]');
        this.interestError = this.querySelector('[data-interest-error]');
        this.closeButtons = Array.from(this.querySelectorAll('[data-close]'));
        this.launcher = this.querySelector('[data-launcher]');

        this.seenKey = `saber_popup:${this.blockId}:seen_session`;
        this.dismissedKey = `saber_popup:${this.blockId}:dismissed_session`;
        this.successKey = `saber_popup:global:success`;
        this.pendingKey = `saber_popup:${this.blockId}:pending`;
        this.savedInterestsKey = `saber_popup:${this.blockId}:interests`;
        this.savedNameKey = `saber_popup:${this.blockId}:first_name`;

        this.opened = false;
        this.timer = null;
        this.scrollBound = false;
        this.bodyState = null;
        this.previousFocus = null;
        this.trackedView = false;
        this.trackedSuccess = false;

        if (
          !this.enabled ||
          !this.backdrop ||
          !this.modal ||
          !this.form
        ) {
          return;
        }

        this.onCloseClick = (event) => {
          event.preventDefault();

          this.close(
            event.currentTarget.dataset.close || 'unknown'
          );
        };

        this.onLauncherClick = (event) => {
          event.preventDefault();
          this.open('launcher', this.launcher);
        };

        this.onBackdropClick = (event) => {
          if (
            this.backdropClose &&
            event.target === this.backdrop
          ) {
            this.close('backdrop');
          }
        };

        this.onInterestChange = () => {
          this.hideInterestError();
        };

        this.onKeydown = (event) => {
          if (!this.opened) return;

          if (event.key === 'Escape') {
            event.preventDefault();
            this.close('escape');
          }

          if (event.key === 'Tab') {
            this.trapFocus(event);
          }
        };

        this.onDocumentClick = (event) => {
          const target =
            event.target instanceof Element
              ? event.target
              : null;

          const opener =
            target &&
            target.closest(
              '[data-saber-popup-open], a[href="#saber-email-popup"]'
            );

          if (
            !opener ||
            !this.handlesOpener(opener)
          ) {
            return;
          }

          event.preventDefault();
          this.open('manual', opener);
        };

        this.onSubmit = (event) => {
          this.hideInterestError();

          if (
            this.showInterests &&
            this.requireInterest &&
            this.selectedTags().length === 0
          ) {
            event.preventDefault();
            this.showInterestError();
            return;
          }

          if (!this.form.checkValidity()) return;

          this.updateTags();
          this.savePending();

          this.track('saber_popup_submit', {
            selectedInterestTags: this.selectedTags()
          });
        };

        this.onResize = () => {
          if (!this.deviceAllowed()) {
            if (this.opened) {
              this.close('resize', {
                store: false,
                track: false,
                launcher: false,
                focus: false
              });
            }

            this.clearTriggers();
            this.showLauncher(false);
            return;
          }

          if (!this.opened) {
            this.start();
          }
        };

        this.onBlockSelect = (event) => {
          if (
            !this.designMode ||
            !(
              event.target === this ||
              event.target.contains(this)
            )
          ) {
            return;
          }

          this.open('theme_editor');
        };

        this.onBlockDeselect = (event) => {
          if (
            !this.designMode ||
            !this.opened ||
            !(
              event.target === this ||
              event.target.contains(this)
            )
          ) {
            return;
          }

          this.close('theme_editor', {
            store: false,
            track: false,
            launcher: false
          });
        };

        this.closeButtons.forEach((button) => {
          button.addEventListener(
            'click',
            this.onCloseClick
          );
        });

        this.interests.forEach((input) => {
          input.addEventListener(
            'change',
            this.onInterestChange
          );
        });

        if (this.launcher) {
          this.launcher.addEventListener(
            'click',
            this.onLauncherClick
          );
        }

        this.backdrop.addEventListener(
          'click',
          this.onBackdropClick
        );

        this.form.addEventListener(
          'submit',
          this.onSubmit
        );

        document.addEventListener(
          'keydown',
          this.onKeydown
        );

        document.addEventListener(
          'click',
          this.onDocumentClick
        );

        document.addEventListener(
          'shopify:block:select',
          this.onBlockSelect
        );

        document.addEventListener(
          'shopify:block:deselect',
          this.onBlockDeselect
        );

        window.addEventListener(
          'resize',
          this.onResize,
          { passive: true }
        );

        this.handleFormReturn();

        if (!this.formReturned) {
          this.start();
        }
      }

      destroy() {
        this.clearTriggers();

        if (!this.enabled) {
          this._ready = false;
          return;
        }

        this.closeButtons?.forEach((button) => {
          button.removeEventListener(
            'click',
            this.onCloseClick
          );
        });

        this.interests?.forEach((input) => {
          input.removeEventListener(
            'change',
            this.onInterestChange
          );
        });

        this.launcher?.removeEventListener(
          'click',
          this.onLauncherClick
        );

        this.backdrop?.removeEventListener(
          'click',
          this.onBackdropClick
        );

        this.form?.removeEventListener(
          'submit',
          this.onSubmit
        );

        document.removeEventListener(
          'keydown',
          this.onKeydown
        );

        document.removeEventListener(
          'click',
          this.onDocumentClick
        );

        document.removeEventListener(
          'shopify:block:select',
          this.onBlockSelect
        );

        document.removeEventListener(
          'shopify:block:deselect',
          this.onBlockDeselect
        );

        window.removeEventListener(
          'resize',
          this.onResize
        );

        if (this.opened) {
          this.close('destroy', {
            store: false,
            track: false,
            launcher: false,
            focus: false
          });
        }

        this._ready = false;
      }

      start() {
        this.clearTriggers();
        this.showLauncher(false);

        if (
          this.designMode ||
          !this.deviceAllowed() ||
          this.customerSubscribed ||
          this.successSuppressed()
        ) {
          return;
        }

        if (this.sessionSeen()) {
          this.showLauncher(true);
          return;
        }

        if (this.trigger === 'manual') {
          this.showLauncher(true);
          return;
        }

        if (
          this.trigger === 'delay' ||
          this.trigger === 'delay_or_scroll'
        ) {
          this.timer = window.setTimeout(
            () => this.autoOpen('delay'),
            Math.max(1, this.delay) * 1000
          );
        }

        if (
          this.trigger === 'scroll' ||
          this.trigger === 'delay_or_scroll'
        ) {
          this.onScroll = () => {
            this.checkScroll();
          };

          window.addEventListener(
            'scroll',
            this.onScroll,
            { passive: true }
          );

          this.scrollBound = true;
          this.checkScroll();
        }
      }

      autoOpen(reason) {
        if (
          this.sessionSeen() ||
          this.successSuppressed() ||
          !this.deviceAllowed()
        ) {
          return;
        }

        this.open(reason);
      }

      checkScroll() {
        const available =
          document.documentElement.scrollHeight -
          window.innerHeight;

        if (available <= 0) return;

        const percent =
          (
            (
              window.scrollY ||
              document.documentElement.scrollTop ||
              0
            ) /
            available
          ) *
          100;

        if (percent >= this.scrollPercent) {
          this.autoOpen('scroll');
        }
      }

      clearTriggers() {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }

        if (
          this.scrollBound &&
          this.onScroll
        ) {
          window.removeEventListener(
            'scroll',
            this.onScroll
          );

          this.scrollBound = false;
        }
      }

      open(reason = 'manual', opener = null) {
        const forcedResult = [
          'form_success',
          'form_error',
          'theme_editor'
        ].includes(reason);

        if (
          !this.enabled ||
          (
            !forcedResult &&
            !this.deviceAllowed()
          )
        ) {
          return;
        }

        if (
          !forcedResult &&
          (
            this.customerSubscribed ||
            this.successSuppressed()
          )
        ) {
          return;
        }

        if (this.opened) return;

        document
          .querySelectorAll(`${TAG}.is-open`)
          .forEach((popup) => {
            if (
              popup !== this &&
              typeof popup.close === 'function'
            ) {
              popup.close('another_popup', {
                store: false,
                track: false,
                launcher: false,
                focus: false
              });
            }
          });

        this.opened = true;
        this.clearTriggers();
        this.showLauncher(false);

        if (
          !this.designMode &&
          ![
            'form_error',
            'form_success'
          ].includes(reason)
        ) {
          this.writeSession(
            this.seenKey,
            '1'
          );
        }

        this.previousFocus =
          opener ||
          document.activeElement;

        this.classList.add('is-open');
        this.backdrop.removeAttribute('inert');
        this.backdrop.setAttribute(
          'aria-hidden',
          'false'
        );

        this.lockBody();
        this.syncAria();

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.initialFocus();
          });
        });

        this.track(
          'saber_popup_view',
          { triggerType: reason },
          'view'
        );
      }

      close(method = 'unknown', options = {}) {
        if (!this.opened) return;

        const settings = Object.assign(
          {
            store: true,
            track: true,
            launcher: true,
            focus: true
          },
          options
        );

        const successVisible =
          this.successPanel &&
          !this.successPanel.hidden;

        this.opened = false;
        this.classList.remove('is-open');

        this.backdrop.setAttribute(
          'aria-hidden',
          'true'
        );

        this.backdrop.setAttribute(
          'inert',
          ''
        );

        this.unlockBody();

        if (
          settings.store &&
          !successVisible &&
          !this.designMode
        ) {
          this.writeSession(
            this.seenKey,
            '1'
          );

          this.writeSession(
            this.dismissedKey,
            '1'
          );
        }

        if (settings.track) {
          this.track(
            'saber_popup_close',
            { closeMethod: method }
          );
        }

        this.showLauncher(
          settings.launcher &&
          !successVisible &&
          this.sessionSeen()
        );

        if (
          settings.focus &&
          this.previousFocus?.isConnected &&
          typeof this.previousFocus.focus === 'function'
        ) {
          this.previousFocus.focus({
            preventScroll: true
          });
        }

        this.previousFocus = null;
      }

      handleFormReturn() {
        this.formReturned = false;

        const success =
          this.formState?.dataset.success === 'true';

        const errors =
          this.formState?.dataset.errors === 'true';

        const pending =
          this.readSession(this.pendingKey) === '1';

        const hashMatch =
          this.hashMatches();

        const belongsHere =
          pending ||
          hashMatch;

        if (
          success &&
          belongsHere
        ) {
          this.formReturned = true;
          this.restoreInterests();
          this.setSuccess(true);

          this.writeLocal(
            this.successKey,
            String(Date.now())
          );

          this.removeSession(this.seenKey);
          this.removeSession(this.dismissedKey);
          this.open('form_success');

          this.track(
            'saber_popup_success',
            {
              selectedInterestTags:
                this.selectedTags()
            },
            'success'
          );

          this.clearPending();
          return;
        }

        if (
          errors &&
          belongsHere
        ) {
          this.formReturned = true;
          this.restorePending();
          this.setSuccess(false);
          this.removeSession(this.pendingKey);
          this.open('form_error');
          return;
        }

        if (
          !success &&
          !errors &&
          pending &&
          hashMatch
        ) {
          this.formReturned = true;
          this.restoreInterests();
          this.setSuccess(true);

          this.writeLocal(
            this.successKey,
            String(Date.now())
          );

          this.removeSession(this.seenKey);
          this.removeSession(this.dismissedKey);
          this.open('form_success');

          this.track(
            'saber_popup_success',
            {
              selectedInterestTags:
                this.selectedTags()
            },
            'success'
          );

          this.clearPending();
          return;
        }

        this.setSuccess(false);
      }

      setSuccess(show) {
        if (this.formPanel) {
          this.formPanel.hidden = show;
        }

        if (this.successPanel) {
          this.successPanel.hidden = !show;
        }

        this.syncAria();
      }

      syncAria() {
        const panel =
          this.successPanel &&
          !this.successPanel.hidden
            ? this.successPanel
            : this.formPanel;

        if (
          !panel ||
          !this.modal
        ) {
          return;
        }

        const heading =
          panel.querySelector('[data-heading]');

        const description =
          panel.querySelector('[data-description]');

        if (heading?.id) {
          this.modal.setAttribute(
            'aria-labelledby',
            heading.id
          );
        } else {
          this.modal.removeAttribute(
            'aria-labelledby'
          );
        }

        if (description?.id) {
          this.modal.setAttribute(
            'aria-describedby',
            description.id
          );
        } else {
          this.modal.removeAttribute(
            'aria-describedby'
          );
        }
      }

      initialFocus() {
        if (!this.opened) return;

        if (
          this.successPanel &&
          !this.successPanel.hidden
        ) {
          return this.successPanel
            .querySelector('[data-heading]')
            ?.focus({
              preventScroll: true
            });
        }

        if (
          this.email?.getAttribute(
            'aria-invalid'
          ) === 'true'
        ) {
          return this.email.focus({
            preventScroll: true
          });
        }

        (
          this.firstName ||
          this.email ||
          this.modal
        ).focus({
          preventScroll: true
        });
      }

      trapFocus(event) {
        const nodes = Array.from(
          this.modal.querySelectorAll(
            'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
          )
        ).filter(
          (node) =>
            !node.closest('[hidden]') &&
            node.getClientRects().length
        );

        if (!nodes.length) {
          event.preventDefault();
          this.modal.focus();
          return;
        }

        const first = nodes[0];
        const last = nodes[nodes.length - 1];

        if (
          event.shiftKey &&
          (
            document.activeElement === first ||
            !this.modal.contains(
              document.activeElement
            )
          )
        ) {
          event.preventDefault();
          last.focus();
        }

        if (
          !event.shiftKey &&
          (
            document.activeElement === last ||
            !this.modal.contains(
              document.activeElement
            )
          )
        ) {
          event.preventDefault();
          first.focus();
        }
      }

      handlesOpener(opener) {
        if (
          !this.enabled ||
          !this.deviceAllowed() ||
          this.customerSubscribed ||
          this.successSuppressed()
        ) {
          return false;
        }

        const targetId =
          opener.getAttribute(
            'data-saber-popup-open'
          );

        if (targetId) {
          return (
            targetId === this.blockId ||
            targetId === this.formId
          );
        }

        return Array.from(
          document.querySelectorAll(TAG)
        ).filter(
          (popup) =>
            popup.enabled &&
            popup.deviceAllowed()
        )[0] === this;
      }

      showLauncher(show) {
        const allowed =
          show &&
          this.showLauncherSetting &&
          !this.designMode &&
          this.deviceAllowed() &&
          !this.customerSubscribed &&
          !this.successSuppressed();

        this.classList.toggle(
          'is-minimized',
          Boolean(allowed)
        );
      }

      deviceAllowed() {
        return window
          .matchMedia('(max-width: 749px)')
          .matches
            ? this.showMobile
            : this.showDesktop;
      }

      sessionSeen() {
        return (
          this.readSession(
            this.seenKey
          ) === '1' ||
          this.readSession(
            this.dismissedKey
          ) === '1'
        );
      }

      successSuppressed() {
        if (this.designMode) return false;

        const time = Number(
          this.readLocal(
            this.successKey
          )
        );

        return (
          Number.isFinite(time) &&
          time > 0 &&
        true
        );
      }

      selectedTags() {
        return this.showInterests
          ? this.interests
              .filter(
                (input) => input.checked
              )
              .map(
                (input) =>
                  input.dataset.interestTag
              )
              .filter(Boolean)
          : [];
      }

      updateTags() {
        if (!this.tags) return;

        const base = (
          this.tags.dataset.baseTags ||
          'newsletter,saber-popup'
        )
          .split(',')
          .map(
            (tag) => tag.trim()
          )
          .filter(Boolean);

        this.tags.value = Array.from(
          new Set([
            ...base,
            ...this.selectedTags()
          ])
        ).join(',');
      }

      showInterestError() {
        if (this.interestError) {
          this.interestError.hidden = false;
        }

        this.interestGroup?.setAttribute(
          'aria-invalid',
          'true'
        );

        this.interests[0]?.focus();
      }

      hideInterestError() {
        if (this.interestError) {
          this.interestError.hidden = true;
        }

        this.interestGroup?.removeAttribute(
          'aria-invalid'
        );
      }

      savePending() {
        this.writeSession(
          this.pendingKey,
          '1'
        );

        this.writeSession(
          this.savedInterestsKey,
          JSON.stringify(
            this.selectedTags()
          )
        );

        this.writeSession(
          this.savedNameKey,
          this.firstName?.value || ''
        );
      }

      restorePending() {
        this.restoreInterests();

        const name =
          this.readSession(
            this.savedNameKey
          );

        if (
          name !== null &&
          this.firstName
        ) {
          this.firstName.value = name;
        }
      }

      restoreInterests() {
        try {
          const saved = JSON.parse(
            this.readSession(
              this.savedInterestsKey
            ) || '[]'
          );

          this.interests.forEach(
            (input) => {
              input.checked =
                saved.includes(
                  input.dataset.interestTag
                );
            }
          );
        } catch (_) {}
      }

      clearPending() {
        [
          this.pendingKey,
          this.savedInterestsKey,
          this.savedNameKey
        ].forEach((key) => {
          this.removeSession(key);
        });
      }

      hashMatches() {
        if (!location.hash) return false;

        try {
          return (
            decodeURIComponent(
              location.hash.slice(1)
            ) === this.formId
          );
        } catch (_) {
          return (
            location.hash.slice(1) ===
            this.formId
          );
        }
      }

      lockBody() {
        if (this.bodyState) return;

        const body = document.body;
        const html =
          document.documentElement;

        const width = Math.max(
          0,
          window.innerWidth -
            html.clientWidth
        );

        const padding =
          parseFloat(
            getComputedStyle(body)
              .paddingRight
          ) || 0;

        this.bodyState = {
          bodyOverflow:
            body.style.overflow,
          bodyPadding:
            body.style.paddingRight,
          htmlOverflow:
            html.style.overflow
        };

        body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';

        if (width) {
          body.style.paddingRight =
            `${padding + width}px`;
        }
      }

      unlockBody() {
        if (!this.bodyState) return;

        document.body.style.overflow =
          this.bodyState.bodyOverflow;

        document.body.style.paddingRight =
          this.bodyState.bodyPadding;

        document.documentElement.style.overflow =
          this.bodyState.htmlOverflow;

        this.bodyState = null;
      }

      track(name, extra = {}, once = '') {
        if (this.designMode) return;

        if (
          once === 'view' &&
          this.trackedView
        ) {
          return;
        }

        if (
          once === 'success' &&
          this.trackedSuccess
        ) {
          return;
        }

        if (once === 'view') {
          this.trackedView = true;
        }

        if (once === 'success') {
          this.trackedSuccess = true;
        }

        const detail = Object.assign(
          {
            blockId: this.blockId
          },
          extra
        );

        try {
          this.dispatchEvent(
            new CustomEvent(
              name,
              {
                bubbles: true,
                detail
              }
            )
          );
        } catch (_) {}

        try {
          if (
            Array.isArray(
              window.dataLayer
            )
          ) {
            window.dataLayer.push(
              Object.assign(
                {
                  event: name
                },
                detail
              )
            );
          }
        } catch (_) {}
      }

      bool(key) {
        return (
          this.dataset[key] === 'true'
        );
      }

      number(key, fallback) {
        const value = Number(
          this.dataset[key]
        );

        return Number.isFinite(value)
          ? value
          : fallback;
      }

      readSession(key) {
        try {
          return sessionStorage.getItem(
            key
          );
        } catch (_) {
          return null;
        }
      }

      writeSession(key, value) {
        try {
          sessionStorage.setItem(
            key,
            value
          );
        } catch (_) {}
      }

      removeSession(key) {
        try {
          sessionStorage.removeItem(
            key
          );
        } catch (_) {}
      }

      readLocal(key) {
        try {
          return localStorage.getItem(
            key
          );
        } catch (_) {
          return null;
        }
      }

      writeLocal(key, value) {
        try {
          localStorage.setItem(
            key,
            value
          );
        } catch (_) {}
      }
    }

    customElements.define(
      TAG,
      SaberEmailPopup
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
